import { call, put } from "typed-redux-saga";
import { BannerSearchResponse } from "../../core/api/requests/banner/search/types";
import { bannerSearchApi } from "../../core/http/httpClient";
import { ApiResponse } from "../../core/types";
import { takeEveryFsa } from "../operations";
import { bannerActions } from "./actions";
import { Banner } from "./types";

export function* bannerSaga() {
  yield takeEveryFsa(bannerActions.getBanners.started, function* (action) {
    const { onComplete, onError, onSuccess, ...body } = action.payload;
    const { response, error }: ApiResponse<BannerSearchResponse> = yield call(
      () => {
        return bannerSearchApi
          .call(body)
          .then((response) => ({ response }))
          .catch((error) => ({ error }));
      },
    );

    onComplete?.();

    if (!response || error) return onError?.(error);

    yield* put(
      bannerActions.getBanners.done({
        params: action.payload,
        result: response.data.banners.map<Banner>((banner) => ({
          id: banner.id,
          image: banner.image,
          displayStart: banner.display_start,
          displayEnd: banner.display_end,
          sortOrder: banner.sort_order,
        })),
      }),
    );
    onSuccess?.(response.data);
  });
}
